import React from "react";
import { withTranslation } from "react-i18next";
import "../css/tagsinput.css";

class Tagsinput extends React.Component {
  state = {
    items: [],
    value: "",
    error: null,
  };

  handleKeyDown = (evt) => {
    if (["Enter", "Tab", ",", " ", "Spacebar"].includes(evt.key)) {
      evt.preventDefault();

      var value = this.state.value.trim();

      if (value && this.isValid(value)) {
        this.setState(
          {
            items: [...this.state.items, this.state.value],
            value: "",
          },
          () => this.props.getItems(this.state.items)
        );
      }
    }
  };

  handleBlur = (evt) => {
    evt.preventDefault();

    var value = this.state.value.trim();

    if (value && this.isValid(value)) {
      this.setState(
        {
          items: [...this.state.items, this.state.value],
          value: "",
        },
        () => this.props.getItems(this.state.items)
      );
    }
  };

  handleChange = (evt) => {
    this.setState({
      value: evt.target.value,
      error: null,
    });
  };

  handleDelete = (item) => {
    this.setState(
      {
        items: this.state.items.filter((i) => i !== item),
      },
      () => this.props.getItems(this.state.items)
    );
  };

  handlePaste = (evt) => {
    evt.preventDefault();

    var paste = evt.clipboardData.getData("text");
    var emails = paste.match(/[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/g);

    if (emails) {
      var toBeAdded = emails.filter((email) => !this.isInList(email));
      this.setState(
        {
          items: [...this.state.items, ...toBeAdded],
        },
        () => this.props.getItems(this.state.items)
      );
    }
  };

  isValid(email) {
    let error = null;

    if (this.isInList(email)) {
      error = `${email} ${this.props.t("event_sso.tagsinput.mail_exist")}`;
    }

    if (!this.isEmail(email)) {
      error = `${email} ${this.props.t("event_sso.tagsinput.not_mail")}`;
    }

    if (error) {
      this.setState({ error });

      return false;
    }

    return true;
  }

  isInList(email) {
    return this.state.items.includes(email);
  }

  isEmail(email) {
    return /[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/.test(email);
  }
  sautDeLigne() {
    if (this.state.items.length > 0) {
      return <br />;
    }
  }
  render() {
    const { t } = this.props;
    return (
      <>
        {this.state.items.map((item) => (
          <div className="tag-item" key={item}>
            {item}
            <button type="button" className="button" onClick={() => this.handleDelete(item)}>
              &times;
            </button>
          </div>
        ))}
        {this.sautDeLigne()}
        <input
          className={"ant-input " + (this.state.error && " has-error")}
          value={this.state.value}
          placeholder={t("event_sso.placeholder.mails")}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          onPaste={this.handlePaste}
          onBlur={this.handleBlur}
        />

        {this.state.error && <p className="error">{this.state.error}</p>}
      </>
    );
  }
}

export default withTranslation()(Tagsinput);
